// ä¸ºäºè§£å³ js è¿ç®çç²¾åº¦é®é¢
export function prettyNumber(n) {
    return Math.abs(n) < 1e-15 ? n : parseFloat(n.toFixed(15));
}
//# sourceMappingURL=pretty-number.js.map